// removed by extract-text-webpack-plugin
module.exports = {"box":"hk-carousel-box"};